// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row[data-v-2e431f71] {\n  margin-bottom: 10px;\n}\n.preference[data-v-2e431f71] {\n  width: 70%;\n  margin: 0 auto;\n  font-size: 25px;\n  color: #1255a0;\n}", ""]);
// Exports
module.exports = exports;
